import { Chip } from '@mui/material';

export const LeadDetailsFn = (CSD) => [
  { field: 'sl_no', headerName: 'Sl.No', width: 110 },
  {
    field: 'lead_owner',
    headerName: 'OWNER',
    width: 250,
    cellStyle: {
      fontWeight: 600,
    },
  },
  {
    field: 'added_by',
    headerName: 'LEAD ADDED BY',
    width: 250,
  },
  {
    field: 'source',
    headerName: 'SOURCES',
    width: 180,
  },
  {
    field: 'sub_source',
    headerName: 'SUB SOURCES',
    width: 180,
  },
  {
    field: 'preferred_project',
    headerName: 'PREFERRED PROJECT',
    width: 220,
    renderCell: ({ value }) => (
      <Chip
        label={value}
        sx={{
          fontWeight: 600,
          bgcolor: '#f4eeff',
          color: '#9e74c8',
        }}
      />
    ),
  },
  {
    field: 'lead_type',
    headerName: 'LEAD TYPE',
    width: 150,
    renderCell: ({ value }) => (
      <Chip
        label={value}
        sx={{
          bgcolor: '#ffeed4',
          color: '#d38a65',
          fontWeight: 600,
        }}
      />
    ),
  },
  ...(!CSD
    ? [
        {
          field: 'total_cost',
          headerName: 'TOTAL COST',
          width: 150,
          cellStyle: {
            color: '#2563EB',
            fontWeight: 600,
          },
        },
        {
          field: 'total_revenue',
          headerName: 'REVENUE',
          width: 150,
          cellStyle: {
            color: '#35b37aff',
            fontWeight: 600,
          },
        },
        {
          field: 'created_date',
          headerName: 'DATE',
          width: 250,
        },
      ]
    : []),

  {
    field: 'lead_number',
    headerName: 'LEAD NUMBER',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ value }) => <Chip label={value} sx={{ color: '#1a79d1ff', fontWeight: 600, bgcolor: '#e1e5ff' }} />,
  },
  ...(CSD
    ? [
        {
          field: 'closed_status',
          headerName: 'CLOSED WON',
          renderCell: ({ value }) => {
            return (
              <Chip
                variant="outlined"
                label={value ? 'closed won' : 'pending'}
                sx={{ fontWeight: 600, color: value ? '#42e950ff' : '#f5c242ff' }}
                color={value ? 'success' : 'warning'}
              />
            );
          },

          width: 250,
        },
      ]
    : []),
];
export const OwnerPerfomanceColumn = [
  {
    field: 'owner',
    headerName: 'OWNER',
    width: 200,
    rowSpan: 3,
  },
  {
    field: 'month',
    headerName: 'MONTH',
    width: 140,
  },
  {
    field: 'total_revenue',
    headerName: 'REVENUE',
    width: 180,
  },
  {
    field: 'total_cost',
    headerName: 'TOTAL COST',
    width: 180,
  },
  {
    field: 'profit_loss',
    headerName: 'PROFIT / LOSS',
    width: 200,
  },
  {
    field: 'converted',
    headerName: 'CONVERTED',
    width: 160,
  },
];
export const countColumn = [
  {
    field: 'leadType',
    headerName: 'Lead Type',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'recordCount',
    headerName: 'Record Count',
    type: 'number',
    flex: 1,
    minWidth: 130,
  },
  {
    field: 'qualifiedCount',
    headerName: 'Qualified Count',
    type: 'number',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'notQualifiedCount',
    headerName: 'Not Qualified Count',
    type: 'number',
    flex: 1,
    minWidth: 170,
  },
];
